import React from 'react';

import ResponsiveContainer from '../components/ResponsiveContainer';
import MapUS from '../components/MapUS';

export default function Home() {
  return (
    <ResponsiveContainer width="100%" aspect={1.5}>
      <MapUS />
    </ResponsiveContainer>
  );
}
